import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

export const VideoContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(239, 239, 239, 0.95);
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 10;
`;

export const VideoPlayer = styled.div`
    background: black;
    width: 270px;
    height: 150px;

    ${BaseStyle.Mixins.screenSizes.medium} {
        width: 540px;
        height: 300px;
    }

    ${BaseStyle.Mixins.screenSizes.large} {
        width: 810px;
        height: 450px;
    }
`;
